export default function formatDate(date: Date): string {
  return (date as any).toString().match(/\w+ (\w+ \d+ \d+)/)[1] || '';
}
